export const USER_AUTHENTICATED = "authenticated";
export const USER_LOGGEDOUT = "logged out";
